import { createContext, useContext } from "react";

/**
 * Lets deeply nested menu content dismiss the whole menu it lives in. Radix
 * only auto-closes on `Item` select; the destination submenu also commits from
 * `SubTrigger` clicks (click a workspace row → copy/move to its root), which
 * Radix treats as "open the submenu", not "select". Menu hosts (RailRowMenu,
 * the pane-header kebab, the canvas command menu, WorkspaceFileRecordMenuSlot)
 * provide their close fn; the default is a no-op so unhosted usage degrades
 * gracefully.
 */
const ObjectActionMenuCloseContext = createContext<() => void>(() => {});

export const ObjectActionMenuCloseProvider =
  ObjectActionMenuCloseContext.Provider;

export function useObjectActionMenuClose(): () => void {
  return useContext(ObjectActionMenuCloseContext);
}
